import { gql } from '__generated__'

export const ClientMe = gql(/* GraphQL */ `
    query ClientMe {
        clientMe {
            id
            user {
                id
                firstName
                lastName
                email
            }
            isAdmin
            company {
                id
                value
            }
        }
    }
`)
